import React, { useEffect, useState, useRef } from "react";
import { withStyles } from "@material-ui/core/styles";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import Card from "@material-ui/core/Card";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import {
  CircleCheckedIcon,
  CircleCrossIcon,
  Close,
  DeleteOverlayCloseIcon,
} from "../../../ofishadmin/views/LeftNav/SvgIcons";
import {
  Button,
  DialogContent,
  FormControlLabel,
  Grid,
  Popover,
} from "@material-ui/core";
import { Document, Page, pdfjs } from "react-pdf";
import { SortedByFilterCheckbox } from "../checkbox/SortedByFilterCheckbox";
import { useDispatch, useSelector } from "react-redux";
import { assetsActions } from "../../../store/assetsManagement/assetsActions";
import { Img } from "react-image";
import { noImage } from "../../../resources/images";
import CircularProgress from "@material-ui/core/CircularProgress";

const StyledMenu = withStyles({
  position: "relative",
})(props => (
  <Menu
    className='modalContent'
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: "center",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "left",
      horizontal: "center",
    }}
    {...props}
  />
));

const useStyles = makeStyles(theme => ({
  customPaper: {
    borderRadius: 20,
  },
  previewBorderRadius: {
    borderRadius: 12,
    overflow: "hidden",
  },
  toolTipContent: {
    backgroundColor: "transparent",
  },
  typography: {
    padding: theme.spacing(2),
  },
  unsupportedFile: {
    width: "400px",
    height: "100px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  dialogTitle: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "16px 24px",
    backgroundColor: "#f5f5f5",
    borderBottom: "1px solid #e0e0e0",
  },
  dialogContent: {
    padding: 0,
    overflow: "hidden",
  },
  fileName: {
    fontWeight: 600,
    fontSize: "1.1rem",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    maxWidth: "calc(100% - 40px)",
  },
  pdfContainer: {
    height: "500px",
    width: "100%",
    overflow: "auto",
    display: "flex",
    justifyContent: "center",
    backgroundColor: "#f5f5f5",
    padding: "20px 0",
  },
  pdfWrapper: {
    width: "100%",
    maxWidth: "800px",
  },
  imageContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#f5f5f5",
    padding: "20px",
  },
  imageStyle: {
    maxWidth: "100%",
    maxHeight: "70vh",
    objectFit: "contain",
  },
  videoContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#000",
    padding: "20px",
  },
  videoStyle: {
    maxWidth: "100%",
    maxHeight: "80vh",
    borderRadius: "8px",
  },
  loadingContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    color: "#666",
    gap: "10px",
  },
  pdfPageContainer: {
    marginBottom: "10px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
    backgroundColor: "white",
    position: "relative",
    minHeight: "50px", // Prevent layout shift
  },
}));

export default function RightClickAssestPreview({
  rightManuBar,
  handleClose,
  assetsMenuBar,
}) {
  return (
    <div className='assetsMenuBar'>
      <StyledMenu
        id='customized-menu'
        anchorEl={rightManuBar}
        keepMounted
        open={Boolean(rightManuBar)}
        onClose={handleClose}>
        {assetsMenuBar.map(currValue => {
          const isFolder = currValue.type === "folder";
          return (
            <div key={currValue.title}>
              <MenuItem
                onClick={() => {
                  currValue.onClick();
                }}
                disabled={isFolder}>
                <ListItemIcon>{currValue.icon}</ListItemIcon>
                <ListItemText
                  className={
                    currValue.title === "Delete"
                      ? "deleteMenuItem"
                      : "otherMenuItem"
                  }
                  primary={currValue.title}
                />
              </MenuItem>
            </div>
          );
        })}
      </StyledMenu>
    </div>
  );
}

export const AssestPreview = ({ open, closeDialog, previewItem }) => {
  const classes = useStyles();
  const handleClose = () => {
    closeDialog();
  };

  const [fileType, setFileType] = useState("");
  const [pageNumber, setPageNumber] = useState([1]);
  const [dialogMaxWidth, setDialogMaxWidth] = useState("sm");
  const [pdfWidth, setPdfWidth] = useState(800);
  const [isPdfLoading, setIsPdfLoading] = useState(false);
  const pdfContainerRef = useRef(null);

  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

  const onPdfLoad = ({ numPages }) => {
    const pagesArray = [];
    for (let i = 1; i <= numPages; i++) {
      pagesArray.push(i);
    }
    setPageNumber([...pagesArray]);
    setIsPdfLoading(false);
  };

  const onPdfLoadStart = () => {
    setIsPdfLoading(true);
  };

  const onPdfLoadError = error => {
    console.error("PDF loading error:", error);
    setIsPdfLoading(false);
  };

  useEffect(() => {
    if (previewItem?.type?.toLowerCase().includes("pdf")) {
      setFileType("pdf");
      setDialogMaxWidth("lg");
    } else if (
      previewItem?.type?.toLowerCase().includes("doc") ||
      previewItem?.type?.toLowerCase().includes("docx")
    ) {
      setFileType("doc");
      setDialogMaxWidth("lg");
    } else if (
      previewItem?.type?.toLowerCase().includes("jpg") ||
      previewItem?.type?.toLowerCase().includes("jpeg") ||
      previewItem?.type?.toLowerCase().includes("png") ||
      previewItem?.type?.toLowerCase().includes("gif") ||
      previewItem?.type?.toLowerCase().includes("jfif") ||
      previewItem?.type?.toLowerCase().includes("webp")
    ) {
      setFileType("image");
      setDialogMaxWidth("md");
    } else if (
      previewItem?.type?.toLowerCase().includes("mp4") ||
      previewItem?.type?.toLowerCase().includes("3gp")
    ) {
      setFileType("video");
      setDialogMaxWidth("md");
    } else {
      setFileType("unknown");
      setDialogMaxWidth("sm");
    }
  }, [previewItem]);

  // Calculate PDF width based on container
  useEffect(() => {
    const updatePdfWidth = () => {
      if (pdfContainerRef.current) {
        const containerWidth = pdfContainerRef.current.clientWidth;
        const calculatedWidth = Math.min(800, containerWidth - 40);
        setPdfWidth(calculatedWidth);
      }
    };

    updatePdfWidth();

    // Update width on window resize
    window.addEventListener("resize", updatePdfWidth);
    return () => window.removeEventListener("resize", updatePdfWidth);
  }, [fileType, open]);

  // Reset states when dialog closes
  useEffect(() => {
    if (!open) {
      setPageNumber([1]);
      setIsPdfLoading(false);
    }
  }, [open]);

  const renderPdf = () => {
    return (
      <div className={classes.pdfContainer} ref={pdfContainerRef}>
        {isPdfLoading && (
          <div className={classes.loadingContainer}>
            <CircularProgress size={40} />
            <div>Loading PDF...</div>
          </div>
        )}

        <Document
          file={previewItem?.url}
          onLoadSuccess={onPdfLoad}
          onLoadError={onPdfLoadError}
          loading={null} // We handle loading ourselves
          onSourceSuccess={onPdfLoadStart}>
          <div className={classes.pdfWrapper}>
            {pageNumber.map(page => (
              <div key={`page_${page}`} className={classes.pdfPageContainer}>
                <Page
                  pageNumber={page}
                  width={pdfWidth}
                  renderTextLayer={false}
                  renderAnnotationLayer={false}
                  loading={
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "500px",
                        color: "#666",
                      }}>
                      Loading page {page}...
                    </div>
                  }
                />
              </div>
            ))}
          </div>
        </Document>
      </div>
    );
  };

  const renderFile = () => {
    switch (fileType) {
      case "pdf":
        return renderPdf();
      case "doc":
      case "docx":
        return (
          <div
            style={{
              height: "500px",
              width: "100%",
              maxWidth: "900px",
              backgroundColor: "#f5f5f5",
            }}>
            <iframe
              title={`${previewItem?.name}.${previewItem?.type}`}
              src={`https://aavazurestorage.blob.core.windows.net/ofishassetsstaging/file_55ab88c2-7f46-45c5-817e-777b099a2dd5`}
              style={{
                width: "100%",
                height: "100%",
                border: "none",
              }}
            />
          </div>
        );
      case "image":
        return (
          <div className={classes.imageContainer}>
            <Img
              src={[previewItem?.url, noImage]}
              className={classes.imageStyle}
              alt={previewItem?.name}
              loader={
                <div className={classes.loadingContainer}>
                  <CircularProgress size={40} />
                  <div>Loading image...</div>
                </div>
              }
            />
          </div>
        );
      case "video":
        return (
          <div className={classes.videoContainer}>
            <video controls className={classes.videoStyle} preload='metadata'>
              <source src={previewItem?.url} />
              Your browser does not support the video tag.
            </video>
          </div>
        );
      default:
        return (
          <div className={classes.unsupportedFile}>
            <p>Unsupported file type</p>
          </div>
        );
    }
  };

  return (
    <div className='Preview'>
      <Dialog
        onClose={handleClose}
        aria-labelledby='customized-dialog-title'
        open={open}
        maxWidth={dialogMaxWidth}
        fullWidth={true}
        classes={{ paper: classes.previewBorderRadius }}>
        <MuiDialogTitle disableTypography className={classes.dialogTitle}>
          <Typography variant='h6' className={classes.fileName}>
            {previewItem?.name}
          </Typography>
          <IconButton aria-label='close' onClick={handleClose} size='small'>
            <Close width={"24"} height={"24"} />
          </IconButton>
        </MuiDialogTitle>
        <DialogContent className={classes.dialogContent}>
          {renderFile()}
        </DialogContent>
      </Dialog>
    </div>
  );
};

export const TooltipPreview = ({ item }) => {
  return (
    <>
      <Card className='smallPreview'>
        <Typography className='title'>{item?.name ?? "No Product"}</Typography>
        <div className='tooltipImg'>
          <Img
            className='previewImageTooltip'
            src={[item?.url, noImage]}
            alt='Preview-Img'
          />
        </div>
      </Card>
    </>
  );
};

export const TooltipDescription = ({
  children,
  title,
  placement,
  disableHoverListener,
}) => {
  const classes = useStyles();
  return (
    <Tooltip
      title={title}
      placement={placement}
      classes={{ tooltip: classes.toolTipContent }}
      disableHoverListener={disableHoverListener}>
      {children}
    </Tooltip>
  );
};

export const DeleteFilesOverlay = ({
  openDeleteFilesOverlay,
  setOpenDeleteFilesOverlay,
  deleteAssetFiles,
  overlayText1,
  overlayText2,
  buttonText,
  isDeleteButton = true,
  heading = "Move Selected Files to Trash",
}) => {
  const classes = useStyles();
  return (
    <div>
      <Dialog
        maxWidth='1100px'
        open={openDeleteFilesOverlay}
        onClose={() => {
          setOpenDeleteFilesOverlay(false);
        }}
        aria-labelledby='responsive-dialog-title'
        classes={{ paper: classes.customPaper }}>
        <Grid className='deleteFilesOverlay'>
          <Grid
            container
            justifyContent='space-between'
            alignItems='center'
            className='deleteHeaderBox'
            style={{
              padding: "24px 32px",
              backgroundColor: "#3699FF",
              color: "#FFFFFF",
            }}>
            <span className='deleteOvelayHeading'>{heading}</span>
            <IconButton
              disableRipple
              aria-label='close'
              onClick={() => {
                setOpenDeleteFilesOverlay(false);
              }}>
              <DeleteOverlayCloseIcon />
            </IconButton>
          </Grid>
          <Grid className='lowerBox'>
            <div className='firstTitle'>{overlayText1}</div>
            <div className='secondTitle'>{overlayText2}</div>
            <Button
              variant='contained'
              className={
                isDeleteButton ? "deleteButton" : "submitOverlayButton"
              }
              onClick={() => {
                deleteAssetFiles();
              }}>
              {buttonText}
            </Button>
          </Grid>
        </Grid>
      </Dialog>
    </div>
  );
};

export const AssetsActionDetials = ({
  id,
  text,
  removeAssetsActionDetials,
}) => {
  return (
    <div className='assetFilesActionUndo'>
      <div
        className='assetsActionDetials'
        style={{ backgroundColor: id === "trash" ? "#E06145" : "#18BC6D" }}>
        <div className='assestCheckedIcon'>
          <CircleCheckedIcon />
          <span>{text}</span>
        </div>
        <IconButton onClick={() => removeAssetsActionDetials()}>
          <CircleCrossIcon />
        </IconButton>
      </div>
    </div>
  );
};

export const SortByFilter = ({ isOpenSortByFilter, setIsOpenSortByFilter }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const {
    orderByAlphabet,
    orderByRecentlyUpdated,
    orderByCreatedDate,
    orderByFileSize,
  } = useSelector(state => state.AssetsReducer);

  const handleClose = () => {
    setIsOpenSortByFilter(null);
  };

  const handleCheckboxChange = prop => {
    if (prop === "orderByAlphabet") {
      dispatch(assetsActions.onChange("orderByAlphabet", !orderByAlphabet));
    } else if (prop === "orderByRecentlyUpdated") {
      dispatch(
        assetsActions.onChange(
          "orderByRecentlyUpdated",
          !orderByRecentlyUpdated
        )
      );
    } else if (prop === "orderByCreatedDate") {
      dispatch(
        assetsActions.onChange("orderByCreatedDate", !orderByCreatedDate)
      );
    } else if (prop === "orderByFileSize") {
      dispatch(assetsActions.onChange("orderByFileSize", !orderByFileSize));
    }
  };

  const id = isOpenSortByFilter ? "simple-popover" : undefined;

  return (
    <div className='sortByFilter' style={{ borderRadius: "10px" }}>
      <Popover
        id={id}
        open={isOpenSortByFilter}
        anchorEl={isOpenSortByFilter}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        classes={{ paper: classes.customPaper }}>
        <Grid className='filterBox'>
          <Grid className='fiterBoxHeader'>
            <span>Sort by</span>
          </Grid>
          <Grid
            container
            direction='column'
            justifyContent='flex-start'
            className='filterContent'>
            <FormControlLabel
              control={
                <SortedByFilterCheckbox
                  handleCheckboxChange={() =>
                    handleCheckboxChange("orderByAlphabet")
                  }
                  checked={orderByAlphabet}
                />
              }
              label='Alphabetical'
            />
            <FormControlLabel
              control={
                <SortedByFilterCheckbox
                  handleCheckboxChange={() =>
                    handleCheckboxChange("orderByRecentlyUpdated")
                  }
                  checked={orderByRecentlyUpdated}
                />
              }
              label='Recently Updated'
            />
            <FormControlLabel
              control={
                <SortedByFilterCheckbox
                  handleCheckboxChange={() =>
                    handleCheckboxChange("orderByCreatedDate")
                  }
                  checked={orderByCreatedDate}
                />
              }
              label='Created Date'
            />
            <FormControlLabel
              control={
                <SortedByFilterCheckbox
                  handleCheckboxChange={() =>
                    handleCheckboxChange("orderByFileSize")
                  }
                  checked={orderByFileSize}
                />
              }
              label='File Size'
            />
          </Grid>
        </Grid>
      </Popover>
    </div>
  );
};
